import React from 'react'
import { Droppable } from 'react-beautiful-dnd'
import ListNodeUI from './ListNodeUI'
import './ListGroup.css'

const ListGroupUI = ({context, messageList, project, taskList, groupTaskId, currentTask, projectUserMap, onSetEditMode,
    onTaskClick, onUnfoldClick, onFoldClick, unfoldedTaskIdSet,
    onTaskNameCreateOrUpdate, moveMode
  }) =>
  <Droppable droppableId={groupTaskId}>
    {provided => (
      <ol
        ref={provided.innerRef}
        {...provided.droppableProps}
        className='list-group'
      >
        {
          taskList
            .filter(task => !task.filtered)
            .map((task, i) =>
            <ListNodeUI
              index={i}
              key={task.taskId}
              context={context}
              project={project}
              task={task}
              messageList={messageList}
              currentTask={currentTask}
              projectUserMap={projectUserMap}
              onSetEditMode={onSetEditMode}
              onTaskClick={onTaskClick}
              onUnfoldClick={onUnfoldClick}
              onFoldClick={onFoldClick}
              unfoldedTaskIdSet={unfoldedTaskIdSet}
              onTaskNameCreateOrUpdate={onTaskNameCreateOrUpdate}
              moveMode={moveMode}
            />
          )
        }
        {provided.placeholder}
      </ol>
    )}
  </Droppable>

export default ListGroupUI
